import styled from "styled-components";

export const StyledOption = styled.p`
  .automation-select-option {
    .menu-option__text {
      width: 100%;
    }
  }
`;

export const StyledContainer = styled.p<{ color: string }>`
  background-color: ${(props) => props.color};
  border-radius: 5px;
  width: 100%;
  color: ${(props) => (props.color === "" ? "black" : "white")};
  padding: 4px 7px 6px 7px;
  text-align: left;
`;
